(function () {
  function q(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function productMain() {
    return q("main[data-template*='product']");
  }

  function norm(value) {
    return (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&|\//g, ' ')
      .replace(/-/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function isHeading(node) {
    return node && node.nodeType === 1 && /H2|H3/.test(node.tagName);
  }

  function isAssociateTitle(text) {
    return /avec quoi.*associ/.test(norm(text));
  }

  function removeSectionFromHeading(heading) {
    var node = heading.nextSibling;

    while (node && !isHeading(node)) {
      var next = node.nextSibling;
      if (node.parentNode) node.parentNode.removeChild(node);
      node = next;
    }

    if (heading.parentNode) heading.parentNode.removeChild(heading);
  }

  function productAccordion() {
    var main = productMain();
    if (!main) return;

    var description =
      q('.product__description', main) ||
      q('[data-product-description]', main) ||
      q('.product-description', main) ||
      q('.product__info-container .rte', main) ||
      q('.product-information .rte', main) ||
      q("main[data-template*='product'] .rte");

    if (!description || description.dataset.impulseDone) return;

    var headings = qa('h2,h3', description);
    if (!headings.length) {
      description.id = description.id || 'impulse-product-info';
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.id = 'impulse-product-info';
    wrapper.className = 'impulse-accordion page-width';

    var count = 0;

    headings.forEach(function (heading) {
      if (isAssociateTitle(heading.textContent)) {
        removeSectionFromHeading(heading);
        return;
      }

      var details = document.createElement('details');
      if (count === 0) details.open = true;

      var summary = document.createElement('summary');
      summary.textContent = heading.textContent;
      details.appendChild(summary);

      var body = document.createElement('div');
      body.className = 'rte';

      var node = heading.nextSibling;
      while (node && !isHeading(node)) {
        var next = node.nextSibling;
        body.appendChild(node);
        node = next;
      }

      heading.remove();
      details.appendChild(body);
      wrapper.appendChild(details);
      count += 1;
    });

    if (count > 0) description.parentNode.insertBefore(wrapper, description);
    description.dataset.impulseDone = '1';
    description.style.display = 'none';
  }

  function pageFaq() {
    var main = q("main[data-template*='page']");
    if (!main) return;

    var rte = q('.rte', main) || q('.page-content', main) || main;
    if (!rte || rte.dataset.impulseFaqDone) return;

    var headings = qa('h3', rte);
    if (!headings.length) return;

    var hasFaq = false;
    qa('h2', rte).forEach(function (heading) {
      if ((heading.textContent || '').toLowerCase().indexOf('faq') > -1) hasFaq = true;
    });

    if (!hasFaq && location.pathname.indexOf('faq') === -1) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'impulse-page-faq page-width';

    headings.forEach(function (heading, index) {
      var details = document.createElement('details');
      if (index === 0) details.open = true;

      var summary = document.createElement('summary');
      summary.textContent = heading.textContent;
      details.appendChild(summary);

      var body = document.createElement('div');
      body.className = 'rte';

      var node = heading.nextSibling;
      while (node && !(node.nodeType === 1 && /H2|H3/.test(node.tagName))) {
        var next = node.nextSibling;
        body.appendChild(node);
        node = next;
      }

      heading.remove();
      details.appendChild(body);
      wrapper.appendChild(details);
    });

    var faqTitle = null;
    qa('h2', rte).forEach(function (heading) {
      if ((heading.textContent || '').toLowerCase().indexOf('faq') > -1) faqTitle = heading;
    });

    if (faqTitle) faqTitle.insertAdjacentElement('afterend', wrapper);
    else rte.appendChild(wrapper);

    rte.dataset.impulseFaqDone = '1';
  }

  function scrollToProductInfo(event) {
    var main = productMain();
    if (!main) return;

    var target =
      q('#impulse-product-info', main) ||
      q('.impulse-accordion', main) ||
      q('.product__description', main) ||
      q('.product-description', main);

    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function productTrust() {
    var main = productMain();
    if (!main) return;

    var form = q("form[action*='/cart/add']", main);
    if (!form) return;

    if (!q('.impulse-product-trust', main)) {
      var trust = document.createElement('div');
      trust.className = 'impulse-product-trust';
      trust.innerHTML = '<strong>Achat sécurisé</strong>Livraison suivie · Retours 14 jours · Conseil taille disponible · Paiement sécurisé<br><a href="/pages/guide-des-tailles">Voir le guide des tailles</a>';
      form.insertAdjacentElement('afterend', trust);
    }

    if (!q('.impulse-more-info-btn', main)) {
      var infoButton = document.createElement('a');
      infoButton.className = 'impulse-more-info-btn';
      infoButton.href = '#impulse-product-info';
      infoButton.textContent = 'Voir plus d’informations produit';
      infoButton.addEventListener('click', scrollToProductInfo);

      var reassurance = q('.impulse-product-trust', main);
      (reassurance || form).insertAdjacentElement('afterend', infoButton);
    }

    if (!q('.impulse-size-link', main)) {
      var picker = q('variant-picker', main) || q('[data-product-variants]', main) || q('fieldset', main);
      if (!picker) return;

      var link = document.createElement('a');
      link.className = 'impulse-size-link';
      link.href = '/pages/guide-des-tailles';
      link.textContent = 'Guide des tailles';
      picker.insertAdjacentElement('afterend', link);
    }
  }

  function selectedColor() {
    var main = productMain();
    if (!main) return '';

    var fieldsets = qa('fieldset', main);

    for (var i = 0; i < fieldsets.length; i += 1) {
      var fieldset = fieldsets[i];

      if (/couleur|color/i.test(fieldset.textContent || '')) {
        var checked = q('input:checked', fieldset);
        if (checked) return (checked.value || checked.getAttribute('aria-label') || '').trim();

        var active = q('[aria-checked="true"],[aria-selected="true"],.is-selected,.selected', fieldset);
        if (active) return (active.getAttribute('aria-label') || active.textContent || '').trim();
      }
    }

    var checkedInputs = qa('input:checked', main).filter(function (input) {
      return /couleur|color/i.test(input.name || '') || /couleur|color/i.test(input.id || '');
    });

    if (checkedInputs[0]) {
      return (checkedInputs[0].value || checkedInputs[0].getAttribute('aria-label') || '').trim();
    }

    var selects = qa('select', main).filter(function (select) {
      return /couleur|color/i.test(select.name || select.id || '') || /couleur|color/i.test((select.closest('label') || {}).textContent || '');
    });

    return selects[0] ? (selects[0].value || '').trim() : '';
  }

  function mediaContainer(img) {
    return img.closest('[data-media-id],li,.product-media-container,.product__media,.product-gallery__media,.media-gallery__item,.slideshow-slide,.slideshow__slide,.slider__slide,.thumbnail-list__item') || img.closest('div') || img;
  }

  function showAllVariantMedia(gallery) {
    qa('[data-impulse-variant-media]', gallery || document).forEach(function (element) {
      element.style.display = element.dataset.impulseDisplay || '';
      element.removeAttribute('data-impulse-hidden');
    });
  }

  function filterVariantMedia() {
    var main = productMain();
    if (!main) return;

    var color = selectedColor();
    var normalized = norm(color);
    var gallery = q('media-gallery', main) || q('[data-product-media-gallery]', main) || q('.product-media-gallery', main) || q('.product__media-wrapper', main) || main;

    if (!normalized) {
      showAllVariantMedia(gallery);
      return;
    }

    var tokens = normalized.split(' ').filter(function (token) {
      return token.length > 1 && ['et', 'de', 'du', 'la', 'le'].indexOf(token) === -1;
    });

    if (!tokens.length) {
      showAllVariantMedia(gallery);
      return;
    }

    var images = qa('img', gallery).filter(function (img) {
      return /cdn.shopify.com/.test(img.src || '') && !img.closest('.impulse-cart-recs') && !img.closest('.impulse-product-trust');
    });

    var entries = [];
    var seen = [];

    images.forEach(function (img) {
      var item = mediaContainer(img);
      if (seen.indexOf(item) > -1) return;
      seen.push(item);

      var haystack = norm((img.alt || '') + ' ' + (img.src || '') + ' ' + (item.getAttribute('aria-label') || '') + ' ' + (item.dataset.mediaId || ''));
      var match = tokens.every(function (token) { return haystack.indexOf(token) > -1; });

      entries.push({ item: item, img: img, match: match });
    });

    var matched = entries.filter(function (entry) { return entry.match; });

    if (!matched.length) {
      showAllVariantMedia(gallery);
      return;
    }

    entries.forEach(function (entry) {
      var element = entry.item;
      element.setAttribute('data-impulse-variant-media', '1');

      if (element.dataset.impulseDisplay === undefined) {
        element.dataset.impulseDisplay = element.style.display || '';
      }

      if (entry.match) {
        element.style.display = element.dataset.impulseDisplay || '';
        element.removeAttribute('data-impulse-hidden');
      } else {
        element.style.display = 'none';
        element.setAttribute('data-impulse-hidden', '1');
      }
    });

    if (matched[0] && matched[0].img) {
      try { matched[0].img.click(); } catch (error) {}
    }
  }

  function sticky() {
    var main = productMain();
    if (!main || window.innerWidth > 749) return;

    var addButton = q("form[action*='/cart/add'] button[type='submit']", main);
    if (!addButton) return;

    var price = q('.price .price-item--regular', main) || q('.price', main) || q('[data-product-price]', main);
    var bar = q('.impulse-sticky-atc');

    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'impulse-sticky-atc';
      bar.innerHTML = '<span></span><button type="button">Ajouter au panier</button>';
      bar.querySelector('button').onclick = function () {
        var current = q("form[action*='/cart/add'] button[type='submit']", productMain());
        if (current && !current.disabled) current.click();
      };
      document.body.appendChild(bar);
    }

    var stickyPrice = q('span', bar);
    var stickyButton = q('button', bar);

    if (stickyPrice) stickyPrice.textContent = price ? price.textContent.trim() : '';
    if (stickyButton) stickyButton.disabled = !!addButton.disabled;
  }

  function ensureFooterLayoutStyles() {
    if (q('#impulse-footer-layout-style')) return;

    var style = document.createElement('style');
    style.id = 'impulse-footer-layout-style';
    style.textContent = '@media (min-width:901px){.impulse-footer-layout{display:flex!important;flex-direction:column!important;align-items:center!important;gap:32px!important;width:100%!important}.impulse-newsletter-zone{width:min(100%,920px)!important;max-width:920px!important;margin:56px auto 34px!important;padding:44px 40px 36px!important;border-top:1px solid rgba(0,0,0,.10)!important;border-bottom:1px solid rgba(0,0,0,.10)!important;text-align:center!important}.impulse-newsletter-zone h1,.impulse-newsletter-zone h2,.impulse-newsletter-zone h3,.impulse-newsletter-zone p,.impulse-newsletter-zone .impulse-club-copy,.impulse-newsletter-zone .impulse-club-copy *{text-align:center!important;margin-left:auto!important;margin-right:auto!important}.impulse-newsletter-zone h1,.impulse-newsletter-zone h2,.impulse-newsletter-zone h3{margin-bottom:18px!important}.impulse-newsletter-zone .impulse-club-copy{max-width:760px!important}.impulse-newsletter-zone .impulse-club-copy p{max-width:760px!important;font-size:clamp(1.05rem,1.55vw,1.35rem)!important;line-height:1.45!important}.impulse-newsletter-zone .impulse-club-copy strong{display:block!important;margin-bottom:12px!important;font-size:clamp(1.18rem,1.85vw,1.75rem)!important;line-height:1.18!important}.impulse-newsletter-zone .impulse-club-benefits{justify-content:center!important;margin:22px auto 28px!important}.impulse-newsletter-zone form,.impulse-newsletter-zone [class*=email-signup]{width:min(100%,860px)!important;max-width:860px!important;margin-left:auto!important;margin-right:auto!important}.impulse-newsletter-zone input[type=email],.impulse-newsletter-zone input[type=text]{min-height:56px!important}.impulse-footer-layout>:not(.impulse-newsletter-zone){width:min(100%,860px)!important;max-width:860px!important;margin-left:auto!important;margin-right:auto!important}.impulse-footer-layout .group-block-content:not(.impulse-newsletter-zone){justify-content:space-between!important}}@media (max-width:900px){.impulse-newsletter-zone{text-align:center!important}.impulse-newsletter-zone .impulse-club-benefits{justify-content:center!important}}';
    document.head.appendChild(style);
  }

  function markNewsletterLayout() {
    ensureFooterLayoutStyles();

    qa('h1,h2,h3').forEach(function (heading) {
      var text = norm(heading.textContent || '');
      if (text !== 'rejoignez le club impulse' && text !== 'rejoignez la communaute') return;

      var zone = heading.parentElement;
      while (zone && zone !== document.body) {
        if (q('form,input[type="email"],[class*="email-signup"]', zone)) break;
        zone = zone.parentElement;
      }

      if (!zone || zone === document.body) zone = heading.parentElement;
      if (!zone) return;

      zone.classList.add('impulse-newsletter-zone');

      var layout = zone.parentElement;
      while (layout && layout !== document.body) {
        var content = norm(layout.textContent || '');
        var hasFooterLinks = content.indexOf('boutique') > -1 && (content.indexOf('politique de retour') > -1 || content.indexOf('clubs pros') > -1 || content.indexOf('a propos') > -1);

        if (hasFooterLinks || q('.menu,[class*="menu"]', layout)) {
          layout.classList.add('impulse-footer-layout');
          break;
        }

        layout = layout.parentElement;
      }
    });
  }

  function newsletter() {
    qa('h1,h2,h3').forEach(function (heading) {
      var text = norm(heading.textContent || '');

      if (text === 'rejoignez la communaute' && !heading.dataset.impulseClubDone) {
        heading.textContent = 'Rejoignez le Club Impulse';
        heading.dataset.impulseClubDone = '1';

        var next = heading.nextElementSibling;
        if (next && next.classList && next.classList.contains('impulse-club-copy')) return;

        var block = document.createElement('div');
        block.className = 'impulse-club-copy';
        block.innerHTML = '<p><strong>Votre accès privilégié à l’univers Impulse Padel.</strong><br>Recevez en avant-première nos lancements, toutes nos actualités et nos conseils terrain pour progresser et performer au padel.</p><ul class="impulse-club-benefits"><li>Avant-premières</li><li>Actualités Impulse</li><li>Conseils performance</li></ul>';
        heading.insertAdjacentElement('afterend', block);
      }
    });

    qa('button,input[type="submit"]').forEach(function (button) {
      var text = (button.textContent || button.value || '').trim();

      if (/s['’]?inscrire/i.test(text) || /inscription/i.test(text)) {
        if (button.tagName === 'INPUT') button.value = 'Entrer dans le Club';
        else button.textContent = 'Entrer dans le Club';
      }
    });

    qa('[role="status"],.form__message,.newsletter-form__message,.email-signup__message,.email-signup__message-text').forEach(function (element) {
      var text = norm(element.textContent || '');

      if (text.indexOf('merci de vous etre abonne') > -1 || text.indexOf('merci pour votre inscription') > -1) {
        element.textContent = 'Bienvenue dans le Club Impulse. Ton accès privilégié est activé.';
      }
    });

    markNewsletterLayout();
  }

  function cart() {
    var drawer = q('cart-drawer') || q('#CartDrawer') || q('.cart-drawer') || q('.drawer');
    if (!drawer) return;

    var footer = q('.drawer__footer', drawer) || q('.cart-drawer__footer', drawer) || q('footer', drawer);
    if (!footer) return;

    if (!q('.impulse-cart-trust', footer)) {
      var trust = document.createElement('div');
      trust.className = 'impulse-cart-trust';
      trust.textContent = 'Paiement sécurisé · Livraison suivie · Retours 14 jours · Conseil taille possible';
      footer.insertBefore(trust, footer.firstChild);
    }

    if (!q('.impulse-cart-recs', drawer)) {
      var template = q('#ImpulseCartRecTemplate');
      if (template && template.content && template.content.children.length) {
        footer.parentNode.insertBefore(template.content.cloneNode(true), footer);
      }
    }
  }

  function run() {
    productAccordion();
    pageFaq();
    productTrust();
    filterVariantMedia();
    sticky();
    cart();
    newsletter();
  }

  var scheduled = false;

  function schedule() {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('change', function () {
    schedule();
    setTimeout(filterVariantMedia, 120);
  }, true);
  document.addEventListener('click', function () {
    schedule();
    setTimeout(filterVariantMedia, 140);
  }, true);

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
